import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlContrato = '/service/materiais/patrimonio/bem/'

class ConsultaBemService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms ? config.adms : []
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            administracao: filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value) : this.state.adms,
            descricaoModelo: filtro.descricaoModelo,
            anoModelo: filtro.anoModelo,
            placa: filtro.placa,
            codigoSituacaoLegal: filtro.codigoSituacaoLegal ? filtro.codigoSituacaoLegal.map(e => e.value) : '',
            identificacao: filtro.identificacao,
        }

        return this.conex.post(urlContrato + 'consultarBem/', JSON.stringify(data))
    }

    todasSituacaoLegal() {
        return this.conex.get(urlContrato + 'situacaoLegal/')
    }
}

export default ConsultaBemService
